/* tslint:disable */
import {
  Company,
  CertificateDesign
} from '../index';

declare var Object: any;
export interface CertificateCategoryInterface {
  "name"?: string;
  "companyId"?: number;
  "createdAt"?: Date;
  "isDeleted"?: boolean;
  "isValidated"?: boolean;
  "images"?: Array<any>;
  "description"?: string;
  "dateDefault"?: string;
  "active"?: boolean;
  "designs"?: Array<any>;
  "id"?: number;
  company?: Company;
  certificateDesigns?: CertificateDesign[];
}

export class CertificateCategory implements CertificateCategoryInterface {
  "name": string;
  "companyId": number;
  "createdAt": Date;
  "isDeleted": boolean;
  "isValidated": boolean;
  "images": Array<any>;
  "description": string;
  "dateDefault": string;
  "active": boolean;
  "designs": Array<any>;
  "id": number;
  company: Company;
  certificateDesigns: CertificateDesign[];
  constructor(data?: CertificateCategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CertificateCategory`.
   */
  public static getModelName() {
    return "CertificateCategory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CertificateCategory for dynamic purposes.
  **/
  public static factory(data: CertificateCategoryInterface): CertificateCategory{
    return new CertificateCategory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CertificateCategory',
      plural: 'CertificateCategories',
      path: 'CertificateCategories',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date',
          default: new Date(0)
        },
        "isDeleted": {
          name: 'isDeleted',
          type: 'boolean',
          default: false
        },
        "isValidated": {
          name: 'isValidated',
          type: 'boolean'
        },
        "images": {
          name: 'images',
          type: 'Array&lt;any&gt;'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "dateDefault": {
          name: 'dateDefault',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean'
        },
        "designs": {
          name: 'designs',
          type: 'Array&lt;any&gt;'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'companyId',
          keyTo: 'id'
        },
        certificateDesigns: {
          name: 'certificateDesigns',
          type: 'CertificateDesign[]',
          model: 'CertificateDesign',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'categoryId'
        },
      }
    }
  }
}
